<template>
  <range-slider
    :id="'x-range-slider-' + name"
    v-model="model"
    class="x-range-slider"
    :min="min"
    :max="max"
    :step="step"
    :name="name"
  />
</template>

<script>
  import RangeSlider from 'vue-range-slider'
  import * as colors from '@/colors'

  export default {
    name: 'XRangeslider',
    components: {
      RangeSlider
    },
    props: {
      min: {
        type: Number,
        required: true
      },
      max: {
        type: Number,
        required: true
      },
      step: {
        type: Number,
        required: false
      },
      name: {
        type: String,
        required: true
      },
      value: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        colors,
        railColor: APP_THEME.palette.primary.main,
        model: this.value
      }
    },

    watch: {
      model (nVal) {
        this.$emit('update', nVal)
      },
      value (nVal) {
        this.model = nVal
      }
    },

    mounted () {
      // Because the component does not support dynamic classes
      // And because it's not possible to use data vars in style
      const rail = document.querySelector(`#x-range-slider-${this.name} .range-slider-fill`)
      rail.style.backgroundColor = this.railColor
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  $slider-height: 20px !default;
  $slider-width: 100% !default;
  $rail-height: 7px !default;
  $knob-size: 30px !default;

  $rail-color: $color-diamond !default;
  $rail-fill-color: $color-meadow !default;
  $knob-color: #fff !default;

  $knob-border: 1px solid #f5f5f5 !default;
  $knob-shadow: 0 -3px 5px 0 rgba(140,140,140,0.2), 0 3px 5px 0 rgba(140,140,140,0.3);

  .range-slider {
    display: inline-block;
    padding: 0 ($knob-size / 2);
    height: $slider-height;
    width: $slider-width;

    &.disabled {
      opacity: 0.5;
    }

    .range-slider-inner {
      display: inline-block;
      position: relative;
      height: 100%;
      width: 100%;
    }

    .range-slider-rail,
    .range-slider-fill {
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      height: $rail-height;
      border-radius: $rail-height / 2;
      transform: translateY(-50%);
    }

    .range-slider-rail {
      width: 100%;
      background-color: $rail-color;
    }

    .range-slider-fill {
      background-color: $rail-fill-color;
    }

    .range-slider-knob {
      display: block;
      position: absolute;
      top: 50%;
      left: 0;
      box-sizing: border-box;
      height: $knob-size;
      width: $knob-size;
      border: $knob-border;
      border-radius: 50%;
      background-color: $knob-color;
      box-shadow: $knob-shadow;
      transform: translate(-50%, -50%);
      cursor: pointer;
    }

    .range-slider-hidden {
      display: none;
    }
  }
</style>
